import { render, staticRenderFns } from "./FiltersGroup.vue?vue&type=template&id=f1248ae0&"
import script from "./FiltersGroup.vue?vue&type=script&lang=js&"
export * from "./FiltersGroup.vue?vue&type=script&lang=js&"
import style0 from "./FiltersGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports